<div *ngIf="selectedFeature.layer.metadata.hoverProperties">
  <div *ngFor="let single of selectedFeature.layer.metadata.hoverProperties.properties">
    {{single | qmCapitalize}}: {{selectedFeature.properties[single]}}
  </div>
  <div *ngIf="selectedFeature.layer.metadata.hoverProperties.coordinates">
    {{'Latidude' | translate}}: {{selectedFeature.geometry.coordinates[1]}}
    <br/>
    {{'Longitude' | translate}}: {{selectedFeature.geometry.coordinates[0]}}
  </div>
</div>
